import { useEffect } from 'react';
import ErrorApi from '../api/error';
import { useAuth0 } from '@auth0/auth0-react';

export default function useErrorRecord(message: string) {
  const { getAccessTokenSilently } = useAuth0();
  useEffect(() => {
    const recordError = async () => {
      try {
        const token = await getAccessTokenSilently();
        void ErrorApi.recordError(token, message);
      } catch (error) {
        console.error(error);
      }
    };
    void recordError();
  }, [getAccessTokenSilently, message]);
}
